import Lottie from "lottie-react";
import dkLoader from "../../../assets/dk-loader.json";
import dkCrown from "../../../assets/dk-crown.png";

// DraftKings gets its own loader (pulsing crown over a green glow); other
// operators keep the default Lottie animation.
const isDraftKings = process.env.REACT_APP_CLIENT === "draftkings";

const GameLoader = () => {
  if (isDraftKings) {
    // Fixed full-screen so it covers whatever wrapper the caller renders.
    return (
      <div className="fixed inset-0 z-10 flex flex-col items-center justify-center gap-6 bg-black bg-[radial-gradient(circle_at_center,rgba(83,211,55,0.25)_0%,rgba(0,0,0,0)_60%)]">
        <img
          src={dkCrown}
          alt="DraftKings"
          className="w-36 animate-logo-pulse"
        />
        <p className="font-inter text-[20px] font-semibold text-[#53D337] [text-shadow:0_0_12px_rgba(83,211,55,0.6)]">
          Loading...
        </p>
      </div>
    );
  }

  return <Lottie animationData={dkLoader} loop autoplay className="w-24 h-24" />;
};

export default GameLoader;
